var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"text-dark",attrs:{"href":"javascript:void(0)"},on:{"click":function($event){return _vm.toggle_fullscreen()}}},[_c('feather',{attrs:{"type":"maximize"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }